(() => {
  const ROOT = '[data-ffs-collection-search]';

  const normalize = (value) =>
    String(value || '')
      .toLowerCase()
      .replace(/[^a-z0-9]+/g, ' ')
      .trim();

  const tokens = (query) => normalize(query).split(/\s+/).filter(Boolean);

  const currentInput = () => document.querySelector(`${ROOT} .ffs-collection-search__input`);

  const currentQuery = () => {
    const input = currentInput();
    return input ? input.value : '';
  };

  let originalCounts = null;

  const snapshotCounts = () => {
    if (originalCounts) return;
    originalCounts = Array.from(document.querySelectorAll('#ProductCountDesktop, #ProductCount')).map(
      (node) => node.innerHTML
    );
  };

  const restoreCounts = () => {
    if (!originalCounts) return;
    document.querySelectorAll('#ProductCountDesktop, #ProductCount').forEach((node, index) => {
      if (originalCounts[index] != null) node.innerHTML = originalCounts[index];
    });
  };

  const apply = (query) => {
    const grid = document.getElementById('product-grid');
    if (!grid) return;

    snapshotCounts();

    const items = grid.querySelectorAll('.grid__item[data-ffs-search]');
    const terms = tokens(query);
    let shown = 0;

    items.forEach((item) => {
      const hay = item.getAttribute('data-ffs-search') || '';
      const match = terms.every((term) => hay.includes(term));
      item.classList.toggle('ffs-collection-search-hidden', !match);
      item.toggleAttribute('hidden', !match);
      if (match) shown += 1;
    });

    const empty = document.getElementById('FfsCollectionSearchEmpty');
    if (empty) {
      empty.hidden = !(terms.length && shown === 0 && items.length > 0);
      const queryEl = empty.querySelector('[data-ffs-search-query]');
      if (queryEl) queryEl.textContent = query.trim();
    }

    document.querySelectorAll(`${ROOT} .ffs-collection-search__clear`).forEach((button) => {
      button.classList.toggle('hidden', !query.trim());
    });

    if (!terms.length) {
      restoreCounts();
      return;
    }

    const label = shown === 1 ? '1 match' : `${shown} matches`;
    document.querySelectorAll('#ProductCountDesktop, #ProductCount').forEach((node) => {
      node.textContent = label;
    });
  };

  const isSearchInput = (target) =>
    target instanceof HTMLInputElement && target.classList.contains('ffs-collection-search__input');

  document.addEventListener(
    'input',
    (event) => {
      if (!isSearchInput(event.target)) return;
      event.stopPropagation();
      apply(event.target.value);
    },
    true
  );

  document.addEventListener(
    'keydown',
    (event) => {
      if (!isSearchInput(event.target)) return;
      if (event.key === 'Enter') event.preventDefault();
      event.stopPropagation();
    },
    true
  );

  document.addEventListener('click', (event) => {
    const clear = event.target.closest(`${ROOT} .ffs-collection-search__clear`);
    if (!clear) return;
    const input = currentInput();
    if (!input) return;
    input.value = '';
    input.focus();
    apply('');
  });

  const start = () => apply(currentQuery());

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start, { once: true });
  } else {
    start();
  }

  window.addEventListener('ffs:catch-slot-updated', () => {
    originalCounts = null;
    apply(currentQuery());
  });
})();
